import { render, staticRenderFns } from "./ToDo.vue?vue&type=template&id=6634bf34&scoped=true&"
import script from "./ToDo.vue?vue&type=script&lang=ts&"
export * from "./ToDo.vue?vue&type=script&lang=ts&"
import style0 from "./ToDo.vue?vue&type=style&index=0&id=6634bf34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6634bf34",
  null
  
)

export default component.exports